module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-2-1dc7641253ad60bb54ee74ec0a9e63ed.jpg";